// src/menu-items/menu.tsx

import { FormattedMessage } from 'react-intl';
import { DashboardOutlined, ManageAccountsOutlined, DescriptionOutlined, ArticleOutlined, DrawOutlined } from '@mui/icons-material';
import { NavItemType } from 'types/menu';

// SVG icons Import
import ReviewIcon from 'components/icons/ReviewIcon';
import TrainingIcon from 'components/icons/TrainingIcon';

// icons
const icons = {
  admin: ManageAccountsOutlined,
  dashboard: DashboardOutlined,
  training: TrainingIcon,
  design: DrawOutlined,
  report: DescriptionOutlined,
  review: ReviewIcon,
  sample: ArticleOutlined
};

const masterMenuList = [
  {
    id: 'dashboard',
    title: <FormattedMessage id="menu.main.dashboard" />,
    type: 'collapse',
    icon: icons.dashboard,
    children: [
      {
        id: 'dashboard-admin',
        title: <FormattedMessage id="menu.main.admin" />,
        type: 'item',
        url: '/dashboard/admin'
      },
      {
        id: 'dashboard-process',
        title: <FormattedMessage id="menu.main.process" />,
        type: 'item',
        url: '/dashboard/process'
      },
      {
        id: 'dashboard-qa',
        title: <FormattedMessage id="menu.main.qaManager" />,
        type: 'item',
        url: '/dashboard/qa-manager'
      }
    ]
  },
  {
    id: 'design',
    title: <FormattedMessage id="menu.main.design" />,
    type: 'collapse',
    icon: icons.design,
    children: [
      {
        id: 'design-document-list',
        title: <FormattedMessage id="menu.main.documentList" />,
        type: 'item',
        url: '/design/document-list'
      },

      {
        id: 'design-master-data',
        title: <FormattedMessage id="menu.main.masterData" />,
        type: 'item',
        url: '/design/master-data'
      }
    ]
  },
  {
    id: 'training',
    title: <FormattedMessage id="menu.main.training" />,
    type: 'collapse',
    icon: icons.training,
    children: [
      {
        id: 'training-model-training',
        title: <FormattedMessage id="menu.main.modelTraining" />,
        type: 'item',
        url: '/training/model-training'
      },
      {
        id: 'training-model-management',
        title: <FormattedMessage id="menu.main.modelManagement" />,
        type: 'item',
        url: '/training/model-management'
      },
      {
        id: 'training-confidence-model',
        title: <FormattedMessage id="menu.main.confidenceModel" />,
        type: 'item',
        url: '/training/confidence-model'
      }
    ]
  },

  {
    id: 'review',
    title: <FormattedMessage id="menu.main.review" />,
    type: 'collapse',
    icon: icons.review,
    children: [
      {
        id: 'review-prediction',
        title: <FormattedMessage id="menu.main.prediction" />,
        type: 'item',
        url: '/review/prediction'
      },
      {
        id: 'review-assurance',
        title: <FormattedMessage id="menu.main.assurance" />,
        type: 'item',
        url: '/review/assurance'
      },
      {
        id: 'review-exception',
        title: <FormattedMessage id="menu.main.exception" />,
        type: 'item',
        url: '/review/exception'
      },
      {
        id: 'review-verification',
        title: <FormattedMessage id="menu.main.verification" />,
        type: 'item',
        url: '/review/verification'
      }
    ]
  },
  {
    id: 'report',
    title: <FormattedMessage id="menu.main.report" />,
    type: 'collapse',
    icon: icons.report,
    children: [
      {
        id: 'report-system',
        title: <FormattedMessage id="menu.main.systemReport" />,
        type: 'item',
        url: '/report/system-report'
      },
      {
        id: 'report-admin',
        title: <FormattedMessage id="menu.main.processReport" />,
        type: 'item',
        url: '/report/process-report'
      }
    ]
  },
  {
    id: 'admin',
    title: <FormattedMessage id="menu.main.admin" />,
    type: 'collapse',
    icon: icons.admin,
    children: [
      {
        id: 'admin-access-management',
        title: <FormattedMessage id="menu.main.accessManagement" />,
        type: 'item',
        url: '/admin/access-management'
      },

      {
        id: 'admin-model-portablilty',
        title: <FormattedMessage id="menu.main.ModelProtablity" />,
        type: 'item',
        url: '/admin/model-portablilty'
      },
      {
        id: 'admin-platform-management',
        title: <FormattedMessage id="menu.main.platformManagement" />,
        type: 'item',
        url: '/admin/platform-management'
      },
      {
        id: 'admin-client-settings',
        title: <FormattedMessage id="menu.main.clientSettings" />,
        type: 'item',
        url: '/admin/client-settings'
      }
    ]
  }
];
const filterMenuItems = (menuItems: NavItemType['children'], enabledMenuIds: Set<string>): NavItemType['children'] => {
  return menuItems
    ? menuItems
        .map((item) => {
          if (item.children) {
            const filteredChildren = filterMenuItems(item.children, enabledMenuIds);
            // Parent item is enabled if at least one child item is enabled
            const isParentEnabled = filteredChildren && filteredChildren.length > 0;

            return {
              ...item,
              children: filteredChildren,
              // Enable the parent if any of its children are enabled
              ...(isParentEnabled ? {} : { id: undefined })
            };
          } else {
            // If the item has no children, check if it's enabled
            const isEnabled = item.id && enabledMenuIds.has(item.id);
            return isEnabled ? item : { ...item, id: undefined };
          }
        })
        .filter((item) => item.id) // Filter out items with undefined IDs
    : [];
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

export const generateMenuList = (enabledMenuIds: Set<string>): NavItemType => ({
  id: 'other',
  title: <FormattedMessage id="others" />,
  type: 'group',
  children: filterMenuItems(masterMenuList, enabledMenuIds)
});
